export const SET_LIKED_USERSLIST = "SET_LIKED_USERSLIST"
export const CLOSE_LIKES_MODAL = "CLOSE_LIKES_MODAL"
export const SET_LIKES_LOADER = "SET_LIKES_LOADER"
export const SET_MORELIKES_LOADER = "SET_MORELIKES_LOADER"


